import React from "react";
import DonutChart from "react-donut-chart";
import styles from './Styles.module.scss'

const DonutChartComponent = ({ data, colors }) => {

    return (
        <div className={styles.donutContainer}>
            <DonutChart
                data={data}
                width={300}
                height={300}
                colors={colors}
                innerRadius={0.6}
                strokeColor={false}
                legend={false}
                // selectedOffset={1}
            // strokeColor="white"
            />
        </div>
    );
};

export default DonutChartComponent;
